// De balk "Testmodus - nog niet live" en het scherm "Binnenkort beschikbaar". (Mollie blok 2, 15-09-2026.)
//
// Afgesproken met Martijn: een winkel die al klaarstaat maar nog niet via Mollie kan betalen, is
// dicht voor gasten en open voor de eigenaar met zijn voorbeeldlink. Zie src/lib/testmodus.js.
import { useSyncExternalStore } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { isBinnenkort, isTestmodus, volgBinnenkort } from "../lib/testmodus";

const stand = () => (isBinnenkort() ? "binnenkort" : isTestmodus() ? "testmodus" : "gewoon");

export default function Testmodus({ children }) {
  const { t } = useTranslation();
  const nu = useSyncExternalStore(volgBinnenkort, stand, stand);

  if (nu === "binnenkort") {
    return (
      <Box
        role="status"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          padding: 3,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h5" component="p" sx={{ textAlign: "center" }}>
          {t("testmodus.binnenkort", "Binnenkort beschikbaar")}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {nu === "testmodus" && (
        <Box
          role="status"
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 2000,
            padding: "6px 12px",
            backgroundColor: "#f59e0b",
            color: "#1f2937",
            fontWeight: 600,
            fontSize: 14,
            textAlign: "center",
          }}
        >
          {t("testmodus.balk", "Testmodus - nog niet live")}
        </Box>
      )}
      {children}
    </>
  );
}

Testmodus.propTypes = {
  children: PropTypes.node,
};
